'use client';
import { SnackbarProvider, useSnackbar } from 'notistack';
import { type ReactNode, useEffect } from 'react';
import { SnackbarUtils } from '@/components/notification/snackbar';

function NotistackRefInitializer() {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  useEffect(() => {
    SnackbarUtils.setSnackbarFuncs(enqueueSnackbar, closeSnackbar);
  }, [enqueueSnackbar, closeSnackbar]);

  return null;
}

export default function SnackbarClientProvider({ children }: { children: ReactNode }) {
  return (
    <SnackbarProvider>
      <NotistackRefInitializer />
      {children}
    </SnackbarProvider>
  );
}
